'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { IconFolderOpen, IconDatabase } from '@tabler/icons-react';
import { ROUTES } from '@/lib/routes';

interface DashboardEmptyStateProps {
  onGoProjects: () => void;
}

export function DashboardEmptyState({ onGoProjects }: DashboardEmptyStateProps) {
  return (
    <div className="p-4 lg:p-6">
      <div className="border rounded-lg bg-card p-12 text-center max-w-lg mx-auto">
        <IconFolderOpen className="size-12 text-muted-foreground/50 mx-auto mb-4" />
        <p className="text-lg font-semibold mb-1">No projects indexed yet</p>
        <p className="text-sm text-muted-foreground mb-6">
          Once projects are scraped and indexed, you&apos;ll see an overview here.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button onClick={onGoProjects}>
            <IconFolderOpen className="size-4 mr-1.5" />
            Go to Projects
          </Button>
          <Button variant="outline" asChild>
            <Link href={ROUTES.sources}>
              <IconDatabase className="size-4 mr-1.5" />
              Run sources
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
